import './HomeLayout.scss';

export default function HomeLayout({ children }: any) {
  return <div className='home-layout'>{children}</div>;
}
